import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	valueInput: {
		marginTop: 4
	}
}))

export default useStyles
